import type { SilverfinContext } from '@app/shared/types/sf-data'
import type { InsightsProperty } from '../types'
import SFetch from '@app/utils/sfetch'

export const getInsightsProperties = ({
  contextType,
  contextId,
}: {
  contextType?: SilverfinContext.Account | SilverfinContext.ReconciliationText
  contextId?: number
} = {}): Promise<InsightsProperty[] | null> => {
  const params = {
    ...window.Silverfin.jsonParams,
    ledger_id: window.Silverfin.currentLedgerId(),
    context_type: contextType,
    context_id: contextId,
  }

  const url = window.Silverfin.Routes.ledger_insight_properties_path(params)

  return SFetch.json<InsightsProperty[]>(url)
}
